import.meta.glob(['@images/**'])
import.meta.env.DEV && import("@styles/main.sass");

import {createApp} from "petite-vue";
import Swiper from "swiper";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import "simple-lightbox/dist/simpleLightbox.css"
import SimpleLightbox from "simple-lightbox"

interface Header {
    opened: boolean

    handleOpenedHeader(state: boolean): void
}

const headerEl = document.querySelector('[data-header]'),
    headerScope: Header = {
        opened: false,
        handleOpenedHeader(state) {
            document.body.classList.toggle("u-hiddenOverflow", state)
        }
    }

headerEl && createApp(headerScope).mount(headerEl);


(() => {
    const factsSwiper = new Swiper('[data-facts-slider]', {
        slidesPerView: 2,
        spaceBetween: 24,
        modules: [Navigation, Autoplay],
        autoplay: true,
        loop: true,
        navigation: {
            nextEl: '.HomeFacts-next',
            prevEl: '.HomeFacts-prev',
        },
        breakpoints: {
            768: {slidesPerView: 3},
        },
    });
})();


(() => {
    const slider = document.querySelector('[data-news-slider]') as HTMLElement;
    if (!slider) return;

    const swiper = new Swiper(slider, {
        slidesPerView: 1,
        autoHeight: true,
        allowTouchMove: true,
        modules: [Navigation],
        navigation: {
            nextEl: "[data-news-next]",
            prevEl: "[data-news-prev]",
        },
        observer: true,
        observeParents: true,
        on: {
            slideChange: () => {
                slider.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    });
})();



(() => {
    if (!document.querySelector('[data-gallery]'))
        return

    new SimpleLightbox({
        elements: '[data-gallery] > a'
    })
})();


(() => {
    const header = document.querySelector('.Header');

    window.addEventListener('scroll', () => {
        if (!header) return;

        const currentScroll = window.scrollY;

        if (currentScroll <= 0) {
            header.classList.remove('scroll-down');
        } else {
            header.classList.add('scroll-down');
        }
    });
})();

(() => {

    function wrapButtonTextInSpan() {
        const buttons = document.querySelectorAll('.wp-block-button__link.wp-element-button');

        buttons.forEach(button => {
            if (button.querySelector('span')) return;

            const text = button.textContent.trim();

            const span = document.createElement('span');
            span.textContent = text;

            button.textContent = '';
            button.appendChild(span);
        });
    }
    wrapButtonTextInSpan();
})();

